import { APP_BASE_URL } from "../../config/api";
import { authFetch } from "../../utils/api";
// Use new backend path: /api/admin/safe/account/{account_id}
const BASE_URL = `${APP_BASE_URL}/api/admin/safe/account`;

export async function fetchAccount(accountId) {
  console.log("🔍 *** Fetching account details for ID:", accountId);
  if (!accountId) {
    console.error("🚨 Account ID is required to fetch account details.");
    throw new Error("Account ID is required.");
  }

  const url = `${BASE_URL}/${accountId}`;
  console.log("🔍 API Call:", { method: "GET", url });

  try {
    const response = await authFetch(url);
    console.log("📥 Response Status:", response.status);
    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ Error fetching account details:", {
        status: response.status,
        statusText: response.statusText,
        body: errorText,
        accountId,
      });
      throw new Error(
        `Failed to fetch account details for ID ${accountId}: ${response.status} ${response.statusText}`,
      );
    }
    const data = await response.json();
    console.log("✅ Success fetching account:", { accountId, data });
    return data;
  } catch (error) {
    console.error("🚨 Request Failed (fetchAccount):", {
      message: error.message,
      accountId,
    });
    throw error;
  }
}
